/* Product Spotlight — carousel mode only.
   Adapted from category-carousel.js; breakpoint values are read from
   data attributes on the section element so merchants can configure
   them per-section in the theme customizer. */

document.querySelectorAll('.ps-carousel-section').forEach(function (section) {
  var sectionId = section.dataset.sectionId;
  var track     = document.getElementById('ps-track-' + sectionId);
  if (!track) return;   /* grid mode — nothing to do */

  var prevBtn   = document.getElementById('ps-prev-' + sectionId);
  var nextBtn   = document.getElementById('ps-next-' + sectionId);
  var viewport  = track.parentElement;
  var cards     = track.querySelectorAll('.carousel-card');
  var GAP       = 24;
  var currentIndex = 0;
  var cardWidth    = 0;  /* cached — only updated on recalculate() */

  var itemsDesktop = parseInt(section.dataset.itemsDesktop, 10) || 4;
  var itemsTablet  = parseInt(section.dataset.itemsTablet,  10) || 2;
  var itemsMobile  = parseInt(section.dataset.itemsMobile,  10) || 1;

  function getVisible() {
    if (window.innerWidth >= 1024) return itemsDesktop;
    if (window.innerWidth >= 768)  return itemsTablet;
    return itemsMobile;
  }

  /* Reads layout once, writes card widths, caches result.
     Only called on load and resize — never during a slide transition. */
  function recalculate() {
    var visible   = getVisible();
    var totalGaps = (visible - 1) * GAP;
    var vw = viewport.offsetWidth;
    cardWidth = (vw - totalGaps) / visible;
    cards.forEach(function (card) { card.style.width = cardWidth + 'px'; });
  }

  /* Writes transform only — no layout reads, safe to call on every click */
  function slide() {
    var visible  = getVisible();
    var maxIndex = Math.max(0, cards.length - visible);
    currentIndex = Math.max(0, Math.min(currentIndex, maxIndex));
    track.style.transform = 'translateX(-' + (currentIndex * (cardWidth + GAP)) + 'px)';
    if (prevBtn) prevBtn.disabled = currentIndex === 0;
    if (nextBtn) nextBtn.disabled = currentIndex >= maxIndex;
  }

  if (nextBtn) nextBtn.addEventListener('click', function () { currentIndex++; slide(); });
  if (prevBtn) prevBtn.addEventListener('click', function () { currentIndex--; slide(); });

  /* Touch swipe */
  var startX = 0;
  track.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
  track.addEventListener('touchend', function (e) {
    var diff = startX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      currentIndex += diff > 0 ? 1 : -1;
      slide();
    }
  });

  /* Debounced resize — recalculates card widths then re-slides to current index */
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      currentIndex = 0;
      recalculate();
      slide();
    }, 150);
  });

  window.addEventListener('load', function () { recalculate(); slide(); });
  recalculate();
  slide();
});
